import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/students/Students';
import StudentDetail from './pages/students/StudentDetail';
import Users from './pages/users/Users';
import Attendance from './pages/attendance/Attendance';
import Leave from './pages/leave/Leave';
import Fees from './pages/fees/Fees';
import FeesStructure from './pages/fees/FeesStructure';
import Assignments from './pages/assignments/Assignments';
import Results from './pages/results/Results';
import Subjects from './pages/subjects/Subjects';
import Exams from './pages/exams/Exams';
import Timetable from './pages/timetable/Timetable';
import Holidays from './pages/holidays/Holidays';
import FoodMenu from './pages/foodmenu/FoodMenu';
import Notifications from './pages/notifications/Notifications';
import Leads from './pages/leads/Leads';
import Vehicles from './pages/vehicles/Vehicles';
import EscortCards from './pages/escort/EscortCards';
import Doubts from './pages/doubts/Doubts';
import Departments from './pages/departments/Departments';
import Institutions from './pages/institutions/Institutions';
import ExcelExport from './pages/exports/ExcelExport';
import Stories from './pages/stories/Stories';
import Activities from './pages/activities/Activities';
import ContentManager from './pages/content/ContentManager';
import StudyMaterials from './pages/studymaterials/StudyMaterials';
import Examination from './pages/hallticket/Examination';
import AcademicCalendar from './pages/calendar/AcademicCalendar';
import Circular from './pages/circular/Circular';
import LearningModules from './pages/learningmodule/LearningModules';

const theme = createTheme({
  palette: {
    primary: { main: '#1a237e' },
    secondary: { main: '#1565c0' },
    background: { default: '#f5f6fa' },
  },
  typography: { fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif' },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none' } } },
    MuiTextField: { defaultProps: { variant: 'outlined' } },
  },
});

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : children;
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/dashboard"     element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/students"      element={<PrivateRoute><Students /></PrivateRoute>} />
            <Route path="/students/:id"  element={<PrivateRoute><StudentDetail /></PrivateRoute>} />
            <Route path="/users"         element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path="/attendance"    element={<PrivateRoute><Attendance /></PrivateRoute>} />
            <Route path="/leave"         element={<PrivateRoute><Leave /></PrivateRoute>} />
            <Route path="/fees"          element={<PrivateRoute><Fees /></PrivateRoute>} />
            <Route path="/fees-structure" element={<PrivateRoute><FeesStructure /></PrivateRoute>} />
            <Route path="/assignments"   element={<PrivateRoute><Assignments /></PrivateRoute>} />
            <Route path="/results"       element={<PrivateRoute><Results /></PrivateRoute>} />
            <Route path="/subjects"      element={<PrivateRoute><Subjects /></PrivateRoute>} />
            <Route path="/exams"         element={<PrivateRoute><Exams /></PrivateRoute>} />
            <Route path="/timetable"     element={<PrivateRoute><Timetable /></PrivateRoute>} />
            <Route path="/holidays"      element={<PrivateRoute><Holidays /></PrivateRoute>} />
            <Route path="/food-menu"     element={<PrivateRoute><FoodMenu /></PrivateRoute>} />
            <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
            <Route path="/circular"      element={<PrivateRoute><Circular /></PrivateRoute>} />
            <Route path="/leads"         element={<PrivateRoute><Leads /></PrivateRoute>} />
            <Route path="/escort-cards"  element={<PrivateRoute><EscortCards /></PrivateRoute>} />
            <Route path="/doubts"        element={<PrivateRoute><Doubts /></PrivateRoute>} />
            <Route path="/departments"   element={<PrivateRoute><Departments /></PrivateRoute>} />
            <Route path="/institutions"  element={<PrivateRoute><Institutions /></PrivateRoute>} />
            <Route path="/exports"       element={<PrivateRoute><ExcelExport /></PrivateRoute>} />
            <Route path="/stories"       element={<PrivateRoute><Stories /></PrivateRoute>} />
            <Route path="/activities"    element={<PrivateRoute><Activities /></PrivateRoute>} />
            <Route path="/content"         element={<PrivateRoute><ContentManager /></PrivateRoute>} />
            <Route path="/study-materials" element={<PrivateRoute><StudyMaterials /></PrivateRoute>} />
            <Route path="/examination"   element={<PrivateRoute><Examination /></PrivateRoute>} />
            <Route path="/academic-calendar" element={<PrivateRoute><AcademicCalendar /></PrivateRoute>} />
            <Route path="/learning-modules" element={<PrivateRoute><LearningModules /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
